import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { getShares } from 'modules/partners/redux/sharesActions';

type UseSharesProps = {
  partnerId: string;
  page: number;
  items: number;
  sortBy?: string;
  sortOrder?: string;
};

export const useShares = ({
  partnerId,
  page,
  items,
  sortBy,
  sortOrder,
}: UseSharesProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchShares = useCallback(async () => {
    if (!partnerId) return;

    try {
      setIsLoading(true);
      await store.dispatch(
        getShares({ partnerId, page, items, sortBy, sortOrder })
      );

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
    }
  }, [partnerId, items, page, sortBy, sortOrder]);

  useEffect(() => {
    fetchShares();
  }, [fetchShares]);

  return { data: {}, isLoading, isError, actions: {} };
};
